module.exports = __webpack_public_path__ + "svg/friends-icon.svg?279b0561076189e153015e1f265ac041";